import API from '@/api/api.js'
import Moment from 'moment';
import Qs from 'qs'

export default class HomeAPIList {
  constructor() {
    let api = new API();
    this.api = api;
  }

  getRenewalList(param, success, error) {
    this.api.get('/renewal', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  getBirthdayList(param, success, error) {
    var param = {
      ...param,
      months: 12
    }
    this.api.get('/home/birthday', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  getMessageList(param, success, error) {
    this.api.get('/home/message', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  getBulletinList(param, success, error) {
    this.api.get('/home/bulletin', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  getBulletinDetail(param, success, error) {
    this.api.get('/home/bulletin/detail', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  getDashboardCharts(param, success, error) {
    this.api.get('/home/dashboard', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  getCustomerPolicyList(params, success, error) {
    this.api.get('/customer/policy', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getCaseTrendChart(params, success, error) {
    this.api.get('/home/dashboard/caseTrend', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getFycTrendChart(params, success, error) {
    this.api.get('/home/dashboard/fycTrend', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getCommTrendChart(params, success, error) {
    this.api.get('/home/dashboard/commissionTrend', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

}



// WEBPACK FOOTER //
// ./src/api/Home/apiList.js